/**
 * Thin analytics façade for the SPA.
 *
 * Reads window.posthog and window.gtag injected by the parent Hugo site's
 * tracking scripts. Both are best-effort — swallow errors so analytics
 * never breaks the user-facing flow.
 */
import { readCampaignParameters } from '../../../../static/js/campaign-attribution.js';

// Capture at SPA entry: client-side question/result navigation removes the query.
// Keeping only campaign slugs in memory preserves attribution without cookies.
const entryCampaign = readCampaignParameters(window.location.search);

declare global {
  interface Window {
    posthog?: {
      capture: (event: string, props?: Record<string, unknown>) => void;
      identify: (id: string, props?: Record<string, unknown>) => void;
    };
    gtag?: (command: string, eventName: string, params?: Record<string, unknown>) => void;
  }
}

export function trackEvent(name: string, props: Record<string, unknown> = {}): void {
  const attributedProps = { ...entryCampaign, ...props };
  try {
    window.posthog?.capture(name, attributedProps);
  } catch {
    /* ignore */
  }
  try {
    window.gtag?.('event', name, attributedProps);
  } catch {
    /* ignore */
  }
}

export function identifyContact(email: string, props: Record<string, unknown> = {}): void {
  try {
    window.posthog?.identify(email, props);
  } catch {
    /* ignore */
  }
}
